import { ExternalLink } from "@indietabletop/appkit/external-link";
import { Link } from "wouter";
import { atomic } from "../atomic.css";
import { links } from "../links";
import { vars } from "../vars.css";
import * as css from "./style.css";

function copyrightRange(createdYear: number) {
  const currentYear = new Date().getFullYear();
  return currentYear === createdYear
    ? `© ${createdYear}`
    : `© ${createdYear}–${currentYear}`;
}

function ReleaseInfo(props: { branch?: string; shortcode?: string }) {
  if (!props.branch || !props.shortcode) {
    return <>Release [local]</>;
  }

  return (
    <>
      {`Release `}
      <code
        style={{
          fontSize: "0.75em",
          backgroundColor: vars.color.backgroundSecondary,
          paddingInline: "0.25rem",
          paddingBlock: "0.125rem",
          borderRadius: "0.25rem",
          fontFamily: "monospace",
        }}
      >
        {props.shortcode}
      </code>
      {props.branch === "main" ? "" : ` (${props.branch})`}.
    </>
  );
}

const link = atomic({
  display: "inline",
  textDecoration: "underline",
});

export function Footer() {
  const fathomAnalytics = (
    <ExternalLink className={link} href={links.fathom}>
      Fathom Analytics
    </ExternalLink>
  );

  const electi = (
    <ExternalLink className={link} href={links.electi}>
      Electi Studio
    </ExternalLink>
  );

  const arturmuller = (
    <ExternalLink className={link} href={links.arturmuller}>
      Artur Müller
    </ExternalLink>
  );

  const itc = (
    <ExternalLink className={link} href={links.itc}>
      Indie Tabletop Club
    </ExternalLink>
  );

  const terms = (
    <Link href="/legal/terms" className={link}>
      Terms of Service
    </Link>
  );

  const privacy = (
    <Link href="/legal/privacy" className={link}>
      Privacy Policy
    </Link>
  );

  const cookies = (
    <Link href="/legal/cookies" className={link}>
      Cookie Policy
    </Link>
  );

  const copyright = copyrightRange(2024);

  return (
    <footer
      className={atomic({
        fontSize: 12,
        lineHeight: 1.5,
        paddingInline: {
          default: 24,
          medium: 56,
        },
        paddingBlock: 24,
      })}
    >
      <div
        className={atomic({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          marginBlockEnd: 24,
          gap: 16,
        })}
      >
        <ExternalLink href={links.electi}>
          <img src="/electi-studio.png" className={css.logo} />
        </ExternalLink>
        <ExternalLink href={links.itc}>
          <img src="/itc-white.svg" className={css.logo} />
        </ExternalLink>
      </div>

      <p className={atomic({ marginBlockEnd: 12 })}>
        This app uses no tracking, other than anonymous, GDPR-compliant{" "}
        {fathomAnalytics}. For more information, see our {terms}, {privacy}, and{" "}
        {cookies}.
      </p>
      <p>
        Eternøl {copyright} Kye Browning. Illustrations & Design {copyright}{" "}
        Till Förster. Published by Electi Studio under license. All rights
        reserved. {electi} {copyright}. Used with permission. App development
        and code {copyright} {arturmuller} via {itc}. All rights reserved.{" "}
        <ReleaseInfo branch={BRANCH} shortcode={COMMIT_SHORTCODE} />
      </p>
    </footer>
  );
}
